export default function (slotId, slotType, slotFamily, outcome) {
    const slot = {
        id: slotId,
        type: slotType,
        family: slotFamily,
        outcomes: []
    };

    slot.condition = outcome.get('condition');

    return slot;
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/factories/SlotFactory.js